import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { SelectorOption } from 'types';
import { signatureTypeOptions, statusOptions } from '../utils/filtersOptions';

type Props = {
  status: SelectorOption | null;
  signatureType: SelectorOption | null;
  onStatusChange: (option: SelectorOption | null) => void; // eslint-disable-line no-unused-vars
  onSignatureTypeChange: (option: SelectorOption | null) => void; // eslint-disable-line no-unused-vars
};

const animatedComponents = makeAnimated();

const EnvelopesListRecentsSectionFilters: FC<Props> = ({
  status,
  signatureType,
  onStatusChange,
  onSignatureTypeChange,
}) => {
  const { t } = useTranslate();

  return (
    <div className="d-flex gx-4">
      <div className="form-group mb-0">
        <label className="form-label">{t('FilterByStatus')}</label>
        <div>
          <Select<SelectorOption>
            id="envelope-filter-status"
            components={animatedComponents}
            options={statusOptions}
            className="react-select w-200px"
            placeholder={t('Alls')}
            isMulti={false}
            value={status}
            onChange={onStatusChange}
            closeMenuOnSelect
            isClearable
          />
        </div>
      </div>

      <div className="form-group mb-0">
        <label className="form-label">{t('FilterByType')}</label>
        <div>
          <Select<SelectorOption>
            id="envelope-filter-type"
            components={animatedComponents}
            options={signatureTypeOptions}
            className="react-select w-200px"
            placeholder={t('Alls')}
            isMulti={false}
            value={signatureType}
            onChange={onSignatureTypeChange}
            closeMenuOnSelect
            isClearable
          />
        </div>
      </div>
    </div>
  );
};

export default EnvelopesListRecentsSectionFilters;
